import type { EntityOption } from '@/components/EntitySelect';
import { getEmployee, listEmployees } from './api';
import { employeeName } from './types';

/** Server search for the employee picker (e.g. manager selection). */
export async function searchEmployees(query: string): Promise<EntityOption[]> {
  const page = await listEmployees({ search: query || undefined });
  return page.results.map((e) => ({ value: String(e.id), label: employeeName(e) }));
}

export async function resolveEmployeeLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const employee = await getEmployee(Number(value));
  return employeeName(employee);
}
